import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@fluentui/react-components";

function Menu() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 24 }}>
      <h1>Menu</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 24 }}>
        <Button appearance="primary" onClick={() => navigate("/transcription")}>Live Transcript</Button>
        <Button onClick={() => navigate("/aiNotEnabled")}>AI Not Enabled</Button>
        <Button onClick={() => navigate("/employeeDetails")}>Employee Details</Button>
        <Button onClick={() => navigate("/success-screen")}>Success</Button>
        <Button onClick={() => navigate("/consentScreen")}>Consent</Button>
        <Button onClick={() => navigate("/observationForm")}>Observation Form</Button>
        <Button onClick={() => navigate("/noAccess")}>No Access</Button>
        <Button onClick={() => navigate("/formSelection")}>Form Selection</Button>
        <Button appearance="primary" onClick={() => navigate("/debug")}>Debug</Button>
      </div>
    </div>
  );
}

export default Menu;
